import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { ActivityServiceService } from 'src/app/services/activity-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-add-activity',
  templateUrl: './add-activity.component.html',
  styleUrls: ['./add-activity.component.scss']
})
export class AddActivityComponent implements OnInit {
  form: FormGroup;
  id: any;
  value: any;
  constructor(
    private formBuilder: FormBuilder,
    private activityService: ActivityServiceService,
    private navigationService: NavigationService,
    private toastr: NotificationService,
    private activateroute: ActivatedRoute,

  ) {
    this.activateroute.params.subscribe((params: any) => {
      debugger
      this.id = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      activityName: [],
      isEmailRequired: [false]
    })
    if (this.id) {
      this.activityService.getActivity(this.id).subscribe((result) => {
        console.log(result)
        this.value = result
        this.form.controls['activityName'].setValue(result.activityName);
        this.form.controls['isEmailRequired'].setValue(result.isEmailRequired);


      })
    }

  }
  gotoactivity() {
    this.navigationService.gotoActivity();

  }
  save() {
    if (this.form.valid) {
      var data
      if (this.id == 0)
         data = this.form.value;
      else
        data={...this.value,...this.form.value}
      this.activityService.saveActivity(data).subscribe((result) => {
        this.toastr.showSuccess("Activity Saved Successfully")
        this.navigationService.gotoActivity();
      })
    }
  }

}
